import React, {useState, useEffect} from 'react';
import { useApi } from '../../../context/ApiProvider';
import moment from 'moment';
import { Link } from 'react-router-dom';
import SearchClients from '../../SearchClients';
import FilterModal from '../../Helpers/Modals/DateFilterModal';
import dayjs from 'dayjs';

function AllDiscrepancies() {
    const [loading, setLoading] = useState(true);
    const [discrepancies, setDiscrepancies] = useState([]);
    const [clients, setClients] = useState([]);
    const [deleteDiscrepancySuccess, setDeleteDiscrepancySuccess] = useState(false);
    const [deleteDiscrepancyError, setDeleteDiscrepancyError] = useState(false);
    const [searchFilter, setSearchFilter] = useState({ fromDate: dayjs().startOf("year"), toDate: dayjs().add(5, "years").endOf("year")});
    const [showFilterModal, setShowFilterModal] = useState(false);
    const Api = useApi();

    useEffect(() => {
        fetchClients();
        fetchDiscrepancies();
    }, []);

    const fetchDiscrepancies = () => {
        Api.get("/rolf/invoicediscrepancies").then((data) => {
            setDiscrepancies(data);
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            setLoading(false);
        });
    }

    const fetchClients = () => {
        Api.get("/rolf/clients").then((data) => {
            setClients(data);
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            setLoading(false);
        });
    }

    const handleDelete = async (clientId, discrepancyId) => {
        if(window.confirm("Are you sure you want to delete this discrepancy?")) {
          await Api.delete(`/rolf/clients/${clientId}/discrepancies/${discrepancyId}`).then(() => {
            setDeleteDiscrepancySuccess('Discrepancy deleted');
            fetchDiscrepancies();
          }).catch(e => {
            console.log(e);
            setDeleteDiscrepancyError('Error deleting discrepancy');
          }).finally(() => {
            setTimeout(() => {
                setDeleteDiscrepancySuccess(false);
                setDeleteDiscrepancyError(false);
            }, 5000)
          })
        }
      }

      const filterDiscrepancies = (discrepancies) => {
        return discrepancies.filter((discrepancy) => {
            const discrepancyFromDate = dayjs.unix(discrepancy.fromDate);
            const discrepancyToDate = dayjs.unix(discrepancy.toDate);
    
            const filterFromDate = dayjs(searchFilter.fromDate);
            const filterToDate = dayjs(searchFilter.toDate);
    
            return (
                discrepancyFromDate.isBefore(filterToDate, "second") &&
                discrepancyToDate.isAfter(filterFromDate, "second")
            );
        });
    };

    if(loading) {
        return <div>Loading...</div>
    }

    return (
        clients && discrepancies ?
        <div>
            <h4>All discrepancies</h4>
            <a href="#" onClick={() => setShowFilterModal(true)}><i className="fa fa-filter" aria-hidden="true"></i> Date Filter</a> <span className='meta'>{dayjs(searchFilter.fromDate).format("YYYY-MM-DD")} - {dayjs(searchFilter.toDate).format("YYYY-MM-DD")}</span>
            <FilterModal isOpen={showFilterModal} onClose={() => setShowFilterModal(false)} searchFilter={searchFilter} setSearchFilter={setSearchFilter} />

            {deleteDiscrepancySuccess ? <p className='formControlSuccess'>{deleteDiscrepancySuccess}</p> : null}
            {deleteDiscrepancyError ? <p className='formControlError'>{deleteDiscrepancyError}</p> : null}

            <table>
                <thead>
                    <tr>
                        <th>Client</th>
                        <th>Discrepancy</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {filterDiscrepancies(discrepancies).map(discrepancy => {

                        let client = clients.find((client) => {
                            return client.ID == discrepancy.clientId;
                        });

                        if(!client) return null;

                        return(
                            <tr key={discrepancy.ID}>
                                <td><Link to={`/rolf/clients/${client.ID}`}>{client.name}</Link></td>
                                <td>{discrepancy.content}</td>
                                <td>{moment.unix(discrepancy.fromDate).format("YYYY-MM-DD")}</td>
                                <td>{moment.unix(discrepancy.toDate).format("YYYY-MM-DD")}</td>
                                <td className='center'>
                                    <a className="warning" onClick={() => handleDelete(client.ID, discrepancy.ID)}><i className="fa fa-trash"></i> Delete</a>
                                </td>
                            </tr>
                        )})}
                </tbody>
            </table>
            <p className='meta'>Discrepacies are added under Rolf Administration &gt; Clients &gt; Select client &gt; Add invoicing discrepancy</p>
        </div> : null
    );


}

export default AllDiscrepancies;